import { 
    IStudyProgram, 
    IPartialResult, 
    IAcademicYear, 
    ICourse 
} from '../models/grade-models';

import { 
    Study, 
    PartialResult, 
    AcademicYear, 
    Course 
} from '../models/grade-viewmodels';

/**
 * Mapper for the Grade List service
 */

export default class GradeListMapper {
    public flattenPartials(partials: IPartialResult[]): IPartialResult[] {
        let partialArr: IPartialResult[] = [];

        const loopPartials = (partialsToLoop: IPartialResult[], children: boolean = false): void => {
            partialsToLoop.forEach(partial => {
                partial.child = children;
                partialArr.push(partial);

                if (partial.partialResults.length > 0) {
                    loopPartials(partial.partialResults, true);
                    partial.partialResults = [];
                }
            });
        }

        loopPartials(partials);
        return partialArr;
    }

    public getlastStudyYear(item: IStudyProgram): number {
        if (item.academicYears.length === 0) {
            return 0;
        }
        return item.academicYears.sort((a, b) => a.year - b.year)[0].year;
    }

    public mapStudyProgram(item: IStudyProgram): Study {
        return new Study(
            item.studyId,
            item.studyDescription,
            item.academicYears.map(entry => this.mapAcademicYear(entry, item.studyId)),
            this.getlastStudyYear(item),
            item.isTranscriptRequestable,
            item.latestAppraisalDate
        );
    }

    public mapAcademicYear(item: IAcademicYear, studyId: string): AcademicYear {
        return new AcademicYear(
            item.year,
            item.creditsEarned,
            item.creditsTotal,
            [],
            false,
            false
        );
    }

    public mapCourse(item: ICourse): Course {
        return new Course(
            item.moduleDescription,
            item.moduleCode,
            item.moduleId,
            item.appraisalId,
            item.period,
            item.creditsEarned,
            item.appraisalDate,
            item.grade,
            item.partialResults == undefined ? [] : item.partialResults.map((entry: IPartialResult) => this.mapResult(entry)),
            false,
            item.isPassed,
            item.isAppraised,
            item.moduleBookingId
        );
    }

    public mapResult(item: IPartialResult): PartialResult {
        return new PartialResult(
            item.appraisalId,
            item.appraisalDate,
            item.period,
            item.appraisalType,
            item.grade,
            item.child,
            item.partialResults == undefined ? [] : item.partialResults.map((entry: IPartialResult) => this.mapResult(entry))
        );
    }
}